import React, { Component } from 'react';
import { serverIp, firebaseAuth, logComponentLoad, } from '../../../../config/constants.js'
import { Table, Header } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants'
import axios from 'axios'
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';

class ViewLargeProjectOrderEntry_options extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            loadingUser: true,
            loading: false,

            largeProjectItemOptions: [],
        }
    }

    componentDidMount() {
        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        });

    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ViewLargeProjectOrderEntry_options");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
            loadingUser: false
        })

    }

    render() {


        const tableRow = this.props.largeProjectItemOptions.length > 0
            ? this.props.largeProjectItemOptions.map((item, index) =>
                <Table.Row>
                    <Table.Cell textAlign='left'> {index + 1} </Table.Cell>
                    <Table.Cell>
                        <Header as='h3' textAlign='left'>
                            {item.categoryOption}
                        </Header>

                    </Table.Cell>
                    <Table.Cell> {item.valueOption} </Table.Cell>
                </Table.Row>)
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser.isAdmin
            ? <div>

                <Table striped>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>#</Table.HeaderCell>
                            <Table.HeaderCell>Item</Table.HeaderCell>
                            <Table.HeaderCell>Value</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {tableRow}
                    </Table.Body>

                </Table>

            </div>
            : <h4>loading error a75</h4>

        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :
            <div>

                {wholeUI}

            </div>
        )
    }
}

export default ViewLargeProjectOrderEntry_options;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/ViewLargeProjectOrderEntry_options.js